import React, { createContext, useContext, useState } from 'react';

/**
 * Activity state shape (matches design pack):
 *   null  → idle (no pill, no toast)
 *   { kind: 'active',   current, total, step, project, items?, eta? }
 *   { kind: 'planning', step, project }
 *   { kind: 'done',     message }   — auto-dismissed toast
 *
 * Any screen calls setActivity(...) to start; setActivity(null) to clear.
 */

const ActivityContext = createContext({ activity: null, setActivity: () => {} });

export function ActivityProvider({ children, initial = null }) {
  const [activity, setActivity] = useState(initial);
  return (
    <ActivityContext.Provider value={{ activity, setActivity }}>
      {children}
    </ActivityContext.Provider>
  );
}

export function useActivity() {
  return useContext(ActivityContext);
}

export default ActivityProvider;
